import { NonIndexRouteObject } from "react-router-dom";
import {
  OutsourcingServicesPage,
  LandingPage,
  OfferPage,
  PrivacyPage,
} from "src/pages";
import { ErrorBoundary } from "src/pages/ErrorBoundary";
import { NotFound } from "src/pages/ErrorBoundary/widgets/NotFound";
import { SnowProvider } from "src/providers/SnowProvider.tsx";
import { RouterWrapper } from "src/widgets";
import {
  KnowledgeBaseArticle,
  KnowledgeBaseFallbackRoute,
  KnowledgeBaseLayout,
  KnowledgeBaseSections,
} from "src/widgets/KnowledgeBase";
import { ARTICLE_ROUTE, routePath } from "src/widgets/KnowledgeBase/constants";

export const PublicRoutes: NonIndexRouteObject[] = [
  {
    path: "/",
    element: <RouterWrapper />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: (
          <SnowProvider>
            <LandingPage />
          </SnowProvider>
        ),
      },
      {
        path: "outsourcing",
        element: <OutsourcingServicesPage />,
      },
      {
        path: "offer",
        element: <OfferPage />,
      },
      {
        path: "privacy",
        element: <PrivacyPage />,
      },
      {
        path: routePath.base,
        element: <KnowledgeBaseLayout />,
        children: [
          {
            index: true,
            element: <KnowledgeBaseSections />,
          },
          {
            path: ARTICLE_ROUTE,
            element: <KnowledgeBaseArticle />,
          },
          {
            path: "*",
            element: <KnowledgeBaseFallbackRoute />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];
